import { render, staticRenderFns } from "./VFatherProPatientsCHCP.vue?vue&type=template&id=8846b72e"
import script from "./VFatherProPatientsCHCP.vue?vue&type=script&lang=js"
export * from "./VFatherProPatientsCHCP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports